/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExercisePrerequisiteDTO } from './ExercisePrerequisiteDTO';
import {
    ExercisePrerequisiteDTOFromJSON,
    ExercisePrerequisiteDTOFromJSONTyped,
    ExercisePrerequisiteDTOToJSON,
    ExercisePrerequisiteDTOToJSONTyped,
} from './ExercisePrerequisiteDTO';
import type { HTTPLink } from './HTTPLink';
import {
    HTTPLinkFromJSON,
    HTTPLinkFromJSONTyped,
    HTTPLinkToJSON,
    HTTPLinkToJSONTyped,
} from './HTTPLink';
import type { ExerciseConfig } from './ExerciseConfig';
import {
    ExerciseConfigFromJSON,
    ExerciseConfigFromJSONTyped,
    ExerciseConfigToJSON,
    ExerciseConfigToJSONTyped,
} from './ExerciseConfig';
import type { EquipmentConfig } from './EquipmentConfig';
import {
    EquipmentConfigFromJSON,
    EquipmentConfigFromJSONTyped,
    EquipmentConfigToJSON,
    EquipmentConfigToJSONTyped,
} from './EquipmentConfig';
import type { MuscleIntensity } from './MuscleIntensity';
import {
    MuscleIntensityFromJSON,
    MuscleIntensityFromJSONTyped,
    MuscleIntensityToJSON,
    MuscleIntensityToJSONTyped,
} from './MuscleIntensity';
import type { SupportExerciseDTO } from './SupportExerciseDTO';
import {
    SupportExerciseDTOFromJSON,
    SupportExerciseDTOFromJSONTyped,
    SupportExerciseDTOToJSON,
    SupportExerciseDTOToJSONTyped,
} from './SupportExerciseDTO';

/**
 * 
 * @export
 * @interface ExerciseDTO
 */
export interface ExerciseDTO {
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    deckId?: string;
    /**
     * 
     * @type {number}
     * @memberof ExerciseDTO
     */
    difficulty: number;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    creatorId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExerciseDTO
     */
    editorIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExerciseDTO
     */
    categoryIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    imageId?: string;
    /**
     * 
     * @type {ExerciseConfig}
     * @memberof ExerciseDTO
     */
    config: ExerciseConfig;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    videoId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    youtubeVideoId?: string;
    /**
     * 
     * @type {Array<MuscleIntensity>}
     * @memberof ExerciseDTO
     */
    muscleIntensities: Array<MuscleIntensity>;
    /**
     * 
     * @type {Array<HTTPLink>}
     * @memberof ExerciseDTO
     */
    links: Array<HTTPLink>;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    mainBodyZoneId: string;
    /**
     * 
     * @type {Array<EquipmentConfig>}
     * @memberof ExerciseDTO
     */
    equipment: Array<EquipmentConfig>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExerciseDTO
     */
    additionalImageIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ExerciseDTO
     */
    publiclyVisible?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExerciseDTO
     */
    progressionExerciseIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExerciseDTO
     */
    regressionExerciseIds: Array<string>;
    /**
     * 
     * @type {Array<SupportExerciseDTO>}
     * @memberof ExerciseDTO
     */
    supportExercises: Array<SupportExerciseDTO>;
    /**
     * 
     * @type {Array<ExercisePrerequisiteDTO>}
     * @memberof ExerciseDTO
     */
    prerequisites: Array<ExercisePrerequisiteDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExerciseDTO
     */
    exerciseFactIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExerciseDTO
     */
    synonyms?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ExerciseDTO
     */
    isUniLateral?: boolean;
}

/**
 * Check if a given object implements the ExerciseDTO interface.
 */
export function instanceOfExerciseDTO(value: object): value is ExerciseDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('difficulty' in value) || value['difficulty'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('creatorId' in value) || value['creatorId'] === undefined) return false;
    if (!('editorIds' in value) || value['editorIds'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('categoryIds' in value) || value['categoryIds'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('muscleIntensities' in value) || value['muscleIntensities'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    if (!('mainBodyZoneId' in value) || value['mainBodyZoneId'] === undefined) return false;
    if (!('equipment' in value) || value['equipment'] === undefined) return false;
    if (!('progressionExerciseIds' in value) || value['progressionExerciseIds'] === undefined) return false;
    if (!('regressionExerciseIds' in value) || value['regressionExerciseIds'] === undefined) return false;
    if (!('supportExercises' in value) || value['supportExercises'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    return true;
}

export function ExerciseDTOFromJSON(json: any): ExerciseDTO {
    return ExerciseDTOFromJSONTyped(json, false);
}

export function ExerciseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExerciseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'deckId': json['deckId'] == null ? undefined : json['deckId'],
        'difficulty': json['difficulty'],
        'name': json['name'],
        'creatorId': json['creatorId'],
        'editorIds': json['editorIds'],
        'description': json['description'],
        'categoryIds': json['categoryIds'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'config': ExerciseConfigFromJSON(json['config']),
        'videoId': json['videoId'] == null ? undefined : json['videoId'],
        'youtubeVideoId': json['youtubeVideoId'] == null ? undefined : json['youtubeVideoId'],
        'muscleIntensities': ((json['muscleIntensities'] as Array<any>).map(MuscleIntensityFromJSON)),
        'links': ((json['links'] as Array<any>).map(HTTPLinkFromJSON)),
        'mainBodyZoneId': json['mainBodyZoneId'],
        'equipment': ((json['equipment'] as Array<any>).map(EquipmentConfigFromJSON)),
        'additionalImageIds': json['additionalImageIds'] == null ? undefined : json['additionalImageIds'],
        'publiclyVisible': json['publiclyVisible'] == null ? undefined : json['publiclyVisible'],
        'progressionExerciseIds': json['progressionExerciseIds'],
        'regressionExerciseIds': json['regressionExerciseIds'],
        'supportExercises': ((json['supportExercises'] as Array<any>).map(SupportExerciseDTOFromJSON)),
        'prerequisites': ((json['prerequisites'] as Array<any>).map(ExercisePrerequisiteDTOFromJSON)),
        'exerciseFactIds': json['exerciseFactIds'] == null ? undefined : json['exerciseFactIds'],
        'synonyms': json['synonyms'] == null ? undefined : json['synonyms'],
        'isUniLateral': json['isUniLateral'] == null ? undefined : json['isUniLateral'],
    };
}

export function ExerciseDTOToJSON(json: any): ExerciseDTO {
    return ExerciseDTOToJSONTyped(json, false);
}

export function ExerciseDTOToJSONTyped(value?: ExerciseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'deckId': value['deckId'],
        'difficulty': value['difficulty'],
        'name': value['name'],
        'creatorId': value['creatorId'],
        'editorIds': value['editorIds'],
        'description': value['description'],
        'categoryIds': value['categoryIds'],
        'imageId': value['imageId'],
        'config': ExerciseConfigToJSON(value['config']),
        'videoId': value['videoId'],
        'youtubeVideoId': value['youtubeVideoId'],
        'muscleIntensities': ((value['muscleIntensities'] as Array<any>).map(MuscleIntensityToJSON)),
        'links': ((value['links'] as Array<any>).map(HTTPLinkToJSON)),
        'mainBodyZoneId': value['mainBodyZoneId'],
        'equipment': ((value['equipment'] as Array<any>).map(EquipmentConfigToJSON)),
        'additionalImageIds': value['additionalImageIds'],
        'publiclyVisible': value['publiclyVisible'],
        'progressionExerciseIds': value['progressionExerciseIds'],
        'regressionExerciseIds': value['regressionExerciseIds'],
        'supportExercises': ((value['supportExercises'] as Array<any>).map(SupportExerciseDTOToJSON)),
        'prerequisites': ((value['prerequisites'] as Array<any>).map(ExercisePrerequisiteDTOToJSON)),
        'exerciseFactIds': value['exerciseFactIds'],
        'synonyms': value['synonyms'],
        'isUniLateral': value['isUniLateral'],
    };
}

